import { render } from "./addBed.vue?vue&type=template&id=7c98b3e0&scoped=true"
import script from "./addBed.vue?vue&type=script&lang=js"
export * from "./addBed.vue?vue&type=script&lang=js"

import "./addBed.vue?vue&type=style&index=0&id=7c98b3e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c98b3e0"]])

export default __exports__